import { IProvidedColumn } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subscription } from 'rxjs';

import {
  AgHeaderExpandComponent,
  IEnhanceHeaderGroupParams,
} from '@features/ag-header-expand/ag-header-expand.component';

import { ButtonComponent } from '@shared/components/button/button.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { QuarterCloseService } from '../quarter-close.service';

interface QCOpenMonthHeaderParams extends IEnhanceHeaderGroupParams {
  collapsedByDefault: boolean;
  disabled: boolean;
  filterCols: (column: IProvidedColumn, index: number, columns: IProvidedColumn[]) => boolean;
  monthButtonClick: () => void;
  tooltip: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ButtonComponent, TooltipDirective],
  styles: `
    :host {
      @apply flex w-full items-center justify-between;
    }
  `,
  template: `
    <div class="flex items-center">
      <span>{{ params.displayName }}</span>
      <aux-icon
        [name]="visible ? 'ChevronLeft' : 'ChevronRight'"
        class="ml-1 cursor-pointer"
        (click)="toggleExpand()"
      />
    </div>

    <aux-button
      [auxTooltip]="tooltip"
      [disabled]="disabled"
      variant="success"
      icon="Check"
      label="Close Month"
      (clickEmit)="params.monthButtonClick()"
    />
  `,
})
export class QCOpenMonthHeaderGroupComponent extends AgHeaderExpandComponent {
  quarterCloseService = inject(QuarterCloseService);

  disabled = true;
  initialized = false;
  params!: QCOpenMonthHeaderParams;
  tooltip = '';

  private externalToggleSubscription?: Subscription;

  agInit(params: QCOpenMonthHeaderParams): void {
    this.params = params;
    this.disabled = params.disabled;
    this.tooltip = params.tooltip;
    this.filterCols = params.filterCols;
    this.visible = !params.collapsedByDefault;
    this.initializeExpandCols();
    this.initialized = true;

    this.externalToggleSubscription = this.quarterCloseService.call$.subscribe((data) => {
      if (data) {
        this.toggleExpand();
      }
    });
  }

  destroy() {
    this.externalToggleSubscription?.unsubscribe();
  }
}
